export default {
    'errors.greaterThan': 'Value can not be greater than 100%. You inserted',
    'errors.required.name': 'Name is required!',
    'errors.unique.name': 'Name must be unique!',
    'errors.required.contact': 'Contact is required!',
    'errors.required.phone': 'Phone Number is required!',
    'errors.required.phonePolicyHolder': 'Phone Number is required for policy holder!',
    'errors.required.email': 'Email is required!',
    'errors.required.code': 'Code is required!',
    'errors.required.endDate': 'End Date is required!',
    'errors.required.tax': 'Tax Number is required!',
    'errors.required.customer': 'Customer is required!',
    'errors.required.commission': 'Commission is required!',
    'errors.required.country': 'Country is required!',
    'errors.notValidAlbania': 'Not a valid address on Albania!',
    'errors.required.plate': 'Plate is required!',
    'errors.required': 'Field is required!',
    'errors.required.vin': 'Vin is required',
    'errors.required.classification': 'Classification is required!',
    'errors.required.city': 'City is required!',
    'errors.required.category': 'Category is required!',
    'errors.required.businessSize': 'Business Size Type is required!',
    'errors.required.legalForm': 'Legal Form Type is required!',
    'errors.required.sectorType': 'Sector Type is required!',
    'errors.required.ownerShip': 'Organization ownership type is required!',
    'errors.required.gender': 'Gender is required!',
    'errors.required.make': 'Make is required!',
    'errors.required.model': 'Model is required!',
    'errors.required.type': 'Type is required!',
    'errors.required.year': 'Year is required!',
    'errors.required.engine': 'Engine is required!',
    'errors.required.volume': 'Volume is required!',
    'errors.required.fuel': 'Fuel is required!',
    'errors.required.capacity': 'Capacity is required!',
    'errors.required.color': 'Color is required!',
    'errors.required.seats': 'Seats is required!',
    'errors.required.writeComment': 'Please write the comment!',
    'errors.exists': 'already exists!',
    'errors.lowerThan': 'Error: Sigal Uniqa Percentage cannot be lower than 0!',
    'errors.renewalsDays': 'The renewal you have selected does not take into account {name} days!',
    'errors.selectAgency': 'Select the new agency first!',
    'errors.alreadyAssigned': 'Agent already is assigned to the selected agency!',
    'errors.required.first.type': 'Select type first!',
    'errors.required.hospital': 'Hospital Type is required!',
    'errors.required.website': 'Website is required!',
    'errors.required.serialCode': 'Serial Code is required!',
    'errors.required.sequence': 'Sequence is required!',
    'errors.required.productCatergoryPath': 'Product Category Path is required!',
    'errors.required.insuranceSectorType': 'Insurance Sector Type is required!',
    'errors.required.insuranceSectorTypee': 'Select Insurance Sector Type',
    'errors.required.description': 'Description is required!',
    'errors.required.years': 'Years are required!',
    'errors.required.months': 'Months are required!',
    'errors.required.days': 'Days are required!',
    'errors.required.serialStart': 'Serial Start is required!',
    'errors.required.serialEnd': 'Serial End is required!',
    'errors.required.agency': 'Agency is required!',
    'errors.required.destination': 'Destination is required!',
    'errors.required.insuredPeriod': 'Insured Period is required!',
    'errors.required.policyHolder': 'Policy Holder is required!',
    'errors.required.beneficiary': 'Beneficiary is required!',
    'errors.required.birthday': 'Birthday is required!',
    'errors.required.startDate': 'Start Date is required!',
    'errors.noDrivers': 'No driver was selected!',
    'errors.driverExists': 'This driver exists. The operation was canceled because you cannot install a duplicate driver!',
    'errors.clientExists': 'This client already exists!',
    'errors.clientisOrganization': 'Client can not be organization type!',
    'errors.usersOrganization': 'User can not be organization type!',
    'errors.notaryPerson': 'Notary can not be person type!',
    'errors.serialNotAble': 'This serial is not able!',
    'errors.required.drivers': 'Error: Policy can not be sold without at least one driver. Please add him!',
    'errors.required.phonePH': 'Error: Policy Holder must have a phone number. Please fill the field!',
    'errors.required.coverages': 'Attention: Before finalizing the sale, choose the policy template!',
    'errors.vehicleGt': 'Error: Vehicle value must be grater than 0',
    'errors.required.dynamicSumInsured': 'Vehicle Value is required!',
    'errors.premiumCalculating': 'Careful: Premium was being calculated. Try again!',
    'errors.vehicleValueFirst': 'Attention: Before choosing the template, set the value of the vehicle!',
    'errors.required.firstName': 'First Name is required!',
    'errors.required.lastName': 'Last Name is required!',
    'errors.required.amfCode': 'AMF Code is required!',
    'errors.required.amfUsername': 'AMF Username is required!',
    'errors.required.amfPassword': 'AMF Password is required!',
    'erros.format.phoneNumber': 'Not a valid phone number!',
    'errors.premiumAdjusted': 'Adjusted premium can not be grater than actual premium gross!',
    'errors.required.location': 'Location is required!',
    'errors.required.duration': 'Duration is required!',
    'errors.required.borderVehicleCategory': 'Border Vehicle Category is required!',
    'errors.required.vehicleFields': 'Vehicle data are required!',
    'errors.required.username': 'Username is required!',
    'errors.required.password': 'Password is required!',
    'errors.confirm.password': 'Please confirm your password!',
    'errors.required.branch': 'Branch is required!',
    'errors.invalid.email': 'This is not a valid email!',
    'errors.required.address': 'Address is required!',
    'errors.required.fiscTcr': 'Bizzness Unit is required!',
    'errors.required.fiscOperatorCode': 'Operator Code is required!',
    'errors.required.bankAccount': 'Bank Account is required!',
    'errors.length.max.18': 'Value should be less than 18 characters!',
    'errors.length.min.18': 'Value should be 18 characters!',
    'errors.required.distributionChannel': 'Distribution Channel is required!',
    'errors.required.dateConfirm': 'Confirmation Date is required!',
    'errors.required.coverageOptions': 'Coverages Options are required!',
    'errors.required.group': 'Group is required!',
    'errors.invalidCustomer': 'Error: Invalid customer. Please fill the correct info or update him!',
    'errors.required.insurer': 'Tpl Insurer is required!',
    'errors.required.tplSerial': 'Tpl Serial is required!',
    'errors.dateLimitReached': 'Date limit reached!',
    'errors.tryAgain': 'Try again later',
    'errors.required.objectName': 'Object Name is required!',
    'errors.required.propertyNumber': 'Property Number is required!',
    'errors.required.surface': 'Surface is required!',
    'errors.required.cadastralArea': 'Cadestral Area is required!',
    'errors.required.identificationNumber': 'Indetification Number is required!',
    'errors.required.identification': 'Identification is required!',
    'errors.required.livestockType': 'Livestock Type is required!',
    'errors.required.cultureType': 'Culture Type is required!',
    'errors.required.area': 'Area is required!',
    'errors.required.greenhouseArticleType': 'Greenhouse Article Type is required!',
    'errors.required.greenhousePropertyType': 'Greenhouse Property Type is required!',
    'errors.required.age': 'Age is required!',
    'errors.required.propertyType': 'Property Type is required!',
    'errors.required.insuredAmount': 'Insured Amount is required!',
    'errors.required.ticketConfirmationDate': 'Ticket confirmation date is required!',
    'error.tooltip.policyHolderLock': 'You can not open policy holder modal because it is lock from checkbox on your left',
    'errors.sameBeneficiary': 'The first beneficiary cannot be the same as the second beneficiary!',
    'errors.sameBeneficiary2': 'The second beneficiary cannot be the same as the first beneficiary!',
    'errors.columnsTotal': 'The sum of the column must be 100%!',
    'errors.ownerShipPercentageTotal': 'The total percentage for column on the table is not 100%, but is {firstArg}!',
    'errors.required.waitingPeriod': 'Waiting Period is required!',
    'errors.required.identifier1': 'Identifier 1 is required!',
    'errors.required.identifier2': 'Identifier 2 is required!',
    'errors.required.productId': 'Product is required!',
    'errors.required.blockedType': 'Blocked Type is required!',
    'errors.invalidCustomersList': 'Warning: The list of insured persons above contains incorrect clients. Please update it!',
    'errors.I00000000I': 'it is not allowed to be the main and only driver',
    'errors.noTemplate': 'Error: This product does not contain any template. Contact the IT department!',
    'errors.templateEmpty': 'Error: The selected package does not contain any coverage. Contact the IT department!',
    'errors.emptyClientsTable': 'Error: The customer list is empty. Complete at least one customer to sell the policy!',
    'errors.premium.zero': 'Error: Policy can not be sold with premium: 0 (zero)!',
    'errors.templates.sublimitsNotAvailable': 'The selected package does not contain sublimits.',
    'errors.required.issueDate': 'Issue date is required!',
    'errors.required.value': 'Value is required!',
    'errors.required.relatedAgencyId': 'Related Agency is required!',
    'errors.required.fullName': 'Full name is required!',
    'errors.required.agencyId': 'Agency is required!',
    'errors.required.confirm_password': 'Password confirmation is required!',
    'errors.minimumReachedBeneficiary': 'You have {firstArg} beneficiaries. Limit is {secondArg} minimum beneficiaries!',
    'errors.minimumReachedInsurer': 'You have {firstArg} insurers. Limit is {secondArg} minimum insurers!',
    'errors.minimumReachedPolicyHolder': 'You have {firstArg} policy holders. Limit is {secondArg} minimum policy holders!',
    'errors.minimumReachedPolicyUser': 'You have {firstArg} policy users. Limit is {secondArg} minimum policy users!',
    'errors.minimumReachedInvoiceRecipient': 'You have {firstArg} invoice recipient. Limit is {secondArg} minimum invoice recipient!',
    'errors.maximumReachedInsurer': 'You have {firstArg} insurers. Limit is {secondArg} maximum insurers!',
    'errors.maximumReachedPolicyHolder': 'You have {firstArg} policy holders. Limit is {secondArg} maximum policy holders!',
    'errors.maximumReachedPolicyUser': 'You have {firstArg} policy users. Limit is {secondArg} maximum policy users!',
    'errors.maximumReachedBeneficiary': 'You have {firstArg} beneficiaries. Limit is {secondArg} maximum beneficiaries!',
    'errors.maximumReachedInvoiceRecipient': 'You have {firstArg} invoice recipient. Limit is {secondArg} maximum invoice recipient!',
    'errors.maximumReached': 'Attention: The number of participants reached the limit!',
    'errors.minimumReached': 'Attention: The number of participants is below the limit!',
    'errors.required.uniqueCode': 'Unique Code is required!',
    'errors.required.motorProduct': 'Motor Product is required!',
    'errors.required.serial': 'Serial is required!',
    'errors.required.articleType': 'Article Type is required!',
    'errors.required.currency': 'Currency is required!',
    'errors.required.paymentType': 'Payment Type is required!',
    'errors.required.riskAddress': 'Risk Address is required!',
    'errors.required.bank': 'Bank is required!',
    'errors.required.bankBranch': 'Bank branch is required!',
    'errors.required.addNotary': 'Notary is required. Click the button above!',
    'errors.required.addInsuranceAgent': 'Insurance Agent is required. Click the button above!',
    'errors.canSell': 'Please contact the IT department. According to the configurations, you cannot sell this product or template!',
    'errors.required.retroactiveDate': 'Retroactive Date is required!',
    'errors.required.accountId': 'Account Id is required!',
    'errors.required.date': 'Date is required!',
    'errors.required.amount': 'Amount is required!',
    'errors.invalidFormFields': 'Invalid form fields!',
    'errors.deleteDisabled': 'You can not delete this entry!',
    'errors.required.add': 'Insured Object is required!',
    'errors.required.specification': 'Specification is required!',
    'errors.required.project': 'Project is required!',
    'errors.required.preventiveValue': 'Preventive value is required!',
    'errors.required.insuredUserLicenseNumber': 'License Number is required!',
    'errors.length.9': 'Value should be less than 9 character',
    'errors.required.product': 'Product is required!',
    'errors.required.vesselCategory': 'Vessel Category is required!',
    'errors.required.material': 'Vessel Material is required!',
    'errors.required.serialNumber': 'Serial Number is required!',
    'errors.required.invoiceNumber': 'Invoice Number is required!',
    'errors.required.purchasePrice': 'Purchase Price is required!',
    'errors.required.purchaseCurrency': 'Purchase Currency is required!',
    'errors.required.sellerWarrantyStartDate': 'Seller Warranty Start Date is required!',
    'errors.required.sellerWarrantyEndDate': 'Seller Warranty End Date is required!',
    'errors.required.channelType': 'Channel Type is required!',
    'errors.required.scopeType': 'Scope Type is required!',
    'errors.required.value': 'Value is required!',
    'errors.required.reason': 'Reason is required!',
};
